import React from 'react';

/* Accordion group for the school detail card. Mirrors
   ios/ProZpects/Views/Components/CollapsibleGroup.swift: caller owns the
   expanded state, header is a real button, chevron rotates.

   `id` is both the DOM id root and the test id, and it matches the iOS
   accessibilityIdentifier / Android testTag for the same group verbatim
   (docs/accessibility-conventions.md — same string on every platform). */

const Chevron = ({ open }) => (
  <svg
    className={`sd-group__chevron${open ? ' sd-group__chevron--open' : ''}`}
    width="13" height="13" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M6 9l6 6 6-6" />
  </svg>
);

const LockIcon = () => (
  <svg className="sd-group__lock" width="12" height="12" viewBox="0 0 24 24"
       fill="none" stroke="currentColor" strokeWidth="2.5"
       strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect x="4" y="11" width="16" height="10" rx="2" />
    <path d="M8 11V7a4 4 0 0 1 8 0v4" />
  </svg>
);

export default function CollapsibleGroup({ id, title, icon, isExpanded, onToggle,
                                           locked = false, children }) {
  const panelId = `${id}_panel`;
  return (
    <div className={`sd-group${locked ? ' sd-group--locked' : ''}`}>
      <button
        type="button"
        className="sd-group__header"
        onClick={locked ? undefined : onToggle}
        disabled={locked}
        aria-disabled={locked || undefined}
        aria-expanded={locked ? undefined : isExpanded}
        aria-controls={locked ? undefined : panelId}
        aria-label={locked ? `${title} — Pro feature, locked` : undefined}
        data-testid={id}
      >
        <span className="sd-group__icon" aria-hidden="true">{icon}</span>
        <span className="sd-group__title">{title}</span>
        {locked ? <LockIcon /> : <Chevron open={isExpanded} />}
      </button>
      {!locked && isExpanded && (
        <div className="sd-group__panel" id={panelId}>{children}</div>
      )}
    </div>
  );
}
